/**
 * @module formatter
 */

/**
 * @param source source string.
 * @param minLength
 * @param appender item appended on left side.
 * 
 * ```ts
 * appendLeft('abc', 1) === 'abc'
 * appendLeft('abc', 5) === '00abc'
 * appendLeft('abc', 5, 'QA') === 'QAQAabc'
 * ```
 */
export function appendLeft(
	source: string | number,
	minLength: number,
	appender: string | number = 0
): string {
	const str = `${source}`;

	if (str.length >= minLength) {
		return str;
	}

	return `${`${appender}`.repeat(minLength - str.length)}${source}`;
}
